"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _constants = require("./constants");

var _uuid = require("uuid");

var _baseParams = _interopRequireDefault(require("./baseParams"));

var _storage = _interopRequireDefault(require("./storage"));

var _utils = require("./utils");

var _excluded = ["session_create_type", "last_session_id"];

var Tracker = /*#__PURE__*/function () {
  function Tracker() {
    (0, _classCallCheck2.default)(this, Tracker);
    this.debugMode = false;
    this.instance = void 0;
    this.sendParams = null;
    this.options = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, _constants.TRACKER_OPTIONS), {}, {
      timezoneOffset: 0,
      env: ''
    });
    this.interceptor = {};
  }

  (0, _createClass2.default)(Tracker, [{
    key: "getBaseParams",
    value: function () {
      var _getBaseParams = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var _this$getOptions, _this$getOptions$time, timezoneOffset, handleBaseParams, session, session_rn, defParams;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$getOptions = this.getOptions(), _this$getOptions$time = _this$getOptions.timezoneOffset, timezoneOffset = _this$getOptions$time === void 0 ? 0 : _this$getOptions$time, handleBaseParams = _this$getOptions.handleBaseParams;
                session = _baseParams.default.getSessionId(30, timezoneOffset);
                session_rn = _baseParams.default.upsetSessionRn(session);
                defParams = {
                  version: _constants.SDK_VERSION,
                  http_cookie: _baseParams.default.getHttpCookie(),
                  url_path: _baseParams.default.getUrlPath(),
                  language: _baseParams.default.getLanguage(),
                  is_mobile: _baseParams.default.getIsMobile(),
                  user_id: _baseParams.default.getUserId(),
                  http_search: _baseParams.default.getHttpSearch(),
                  title: _baseParams.default.getTitle(),
                  session_id: session.sid,
                  session_create_time: session.createAt,
                  session_rn: session_rn,
                  last_session_id: session.last_session_id,
                  session_create_type: session.session_create_type,
                  is_pc: _baseParams.default.getWebsite(),
                  loading_time: _baseParams.default.getPerformance().load,
                  event_created_at_ms: +new Date(),
                  screen_width: _baseParams.default.getScreenWidth(),
                  screen_height: _baseParams.default.getScreenHeight(),
                  http_domain: _baseParams.default.getDomain()
                };

                if (!(handleBaseParams && typeof handleBaseParams === 'function')) {
                  _context.next = 7;
                  break;
                }

                _context.next = 7;
                return handleBaseParams(defParams);

              case 7:
                return _context.abrupt("return", defParams);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getBaseParams() {
        return _getBaseParams.apply(this, arguments);
      }

      return getBaseParams;
    }()
  }, {
    key: "checkParams",
    value: function checkParams(params) {
      var ret = true;

      var withoutKeys = _constants.REQUIRED_PARAM_KEYS.filter(function (key) {
        return !params[key];
      });

      if (withoutKeys.length) {
        console.error("".concat(withoutKeys, " is necessary"));
        ret = false;
      }

      if (!_constants.ENV_LIST.includes(params.env)) {
        console.error("env is must be one of ".concat(_constants.ENV_LIST));
        ret = false;
      }

      if (!ret) {
        console.error('tracking failure');
      }

      return ret;
    }
    /**
     * @description 上报metrics事件
     * @param sendParams 上报的源事件数据
     * @param isHttpReport 是否使用http上报，根据业务前端选择决定
     * @returns
     */

  }, {
    key: "reportMetric",
    value: function reportMetric(sendParams, isHttpReport) {
      var metricParams = (0, _objectSpread2.default)((0, _objectSpread2.default)({
        act: _constants.METRIC_ACT,
        time: new Date().getTime()
      }, (0, _utils.pick)(sendParams, _constants.METRIC_PARAM_KEYS)), {}, {
        events: Object.assign((0, _utils.pick)(sendParams, _constants.METRIC_EVENT_PARAM_KEYS), {
          metric_value: 1
        })
      });
      var reportParamsEncoded = Tracker.encodeParams(metricParams);
      var eventsEncoded = Tracker.encodeParams(metricParams.events);
      reportParamsEncoded.events = JSON.stringify(eventsEncoded);

      if (this.debugMode) {
        return;
      }

      var instance = this.getInstance();
      var res = isHttpReport ? instance === null || instance === void 0 ? void 0 : instance.httpInstance.report(reportParamsEncoded, true) : instance === null || instance === void 0 ? void 0 : instance.report(reportParamsEncoded, true);
      return res;
    }
  }, {
    key: "setOptions",
    value: function setOptions(options) {
      this.options = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.options), options);
    }
  }, {
    key: "getOptions",
    value: function getOptions() {
      return this.options;
    }
  }, {
    key: "setSendParams",
    value: function setSendParams(params) {
      this.sendParams = params;
    }
  }, {
    key: "setDebugMode",
    value: function setDebugMode(debugMode) {
      this.debugMode = debugMode;
    }
  }, {
    key: "initInstance",
    value: function initInstance() {
      var _this$options$customD, _this$options;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      // SDK支持后优化
      var hdSdk = require('@yy/shopline-hiido-sdk/libs/bundles/universal');

      if (hdSdk && hdSdk.default) {
        hdSdk = hdSdk.default;
      }

      return hdSdk((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.options), options), {}, {
        domain: "".concat((_this$options$customD = (_this$options = this.options) === null || _this$options === void 0 ? void 0 : _this$options.customDomain) !== null && _this$options$customD !== void 0 ? _this$options$customD : window.location.host, "/eclytics")
      }));
    }
  }, {
    key: "use",
    value: function use(type, callback) {
      switch (type) {
        case 'url':
        case 'request':
          // 转发一下
          this.interceptor[type] = callback;
          break;

        default:
          if (this.instance) {
            this._instanceUse(type, callback);
          } else {
            this.interceptor[type] = callback;
          }

      }
    }
  }, {
    key: "_instanceUse",
    value: function _instanceUse(type, callback) {
      var _this = this;

      this.instance.use(type, callback);
      ['httpInstance', 'beaconInstance'].forEach(function (key) {
        var _this$instance$key;

        (_this$instance$key = _this.instance[key]) === null || _this$instance$key === void 0 ? void 0 : _this$instance$key.use(type, callback);
      });
    }
  }, {
    key: "getInstance",
    value: function getInstance() {
      var _this2 = this;

      if (!this.instance) {
        this.instance = this.initInstance();
        var tid = (0, _uuid.v4)();

        var matchPv = function matchPv(options) {
          options = [].concat(options);
          var re = 0;

          if (options && options.length) {
            re = options.some(function (opt) {
              var _opt$source, _opt$source$moreinfo, _opt$source2;

              return ((_opt$source = opt.source) === null || _opt$source === void 0 ? void 0 : (_opt$source$moreinfo = _opt$source.moreinfo) === null || _opt$source$moreinfo === void 0 ? void 0 : _opt$source$moreinfo.event_name) == '101' && ((_opt$source2 = opt.source) === null || _opt$source2 === void 0 ? void 0 : _opt$source2.eventid) == '60006253';
            });
          }

          return Number(re);
        };

        var useUrlCallback = function useUrlCallback(url, payload, options) {
          var _this2$getOptions = _this2.getOptions(),
              _this2$getOptions$que = _this2$getOptions.queryParams,
              queryParams = _this2$getOptions$que === void 0 ? {} : _this2$getOptions$que;

          var sendParams = _this2.sendParams;

          if (typeof _this2.interceptor['url'] === 'function') {
            url = _this2.interceptor['url'](url, payload, options);
          }

          var _baseParams$getSessio = _baseParams.default.getSession(),
              value = _baseParams$getSessio.value;

          if (value && value.sid) {
            var sid = value.sid;
            var sct = value.createAt; // payload在n.gif为对象，o.gif为数组，统一转为数组处理

            var payloads = [].concat(payload);
            var pv = matchPv(payloads);
            var urlQuery = (0, _objectSpread2.default)({
              _sid: sid,
              _sct: sct,
              _tid: tid,
              _pdppv: pv,
              _bcount: payloads.length
            }, typeof queryParams === 'function' ? queryParams(sendParams) : queryParams);
            return "".concat(url).concat(url.indexOf('?') === -1 ? "?" : '&').concat((0, _utils.qsStringify)(urlQuery));
          }

          return url;
        }; // 新协议修改request_time为event_sent_at_ms


        var useRequestCallback = function useRequestCallback(data) {
          if (data.act !== _constants.ACT) return data;
          var result = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, data), {}, {
            event_sent_at_ms: data.request_time
          });
          delete result.request_time;
          return result;
        };

        this._instanceUse('url', useUrlCallback);

        this._instanceUse('request', useRequestCallback);

        Object.keys(this.interceptor).filter(function (key) {
          return !/(url|request)/.test(key);
        }).forEach(function (key) {
          if (typeof _this2.interceptor[key] === 'function') {
            _this2._instanceUse(key, _this2.interceptor[key]);
          }
        });
      }

      return this.instance;
    }
    /**
     * 基础协议上报
     * @param params
     */

  }, {
    key: "reportHeart",
    value: function () {
      var _reportHeart = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var params,
            _args2 = arguments;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                params = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {
                  action_type: _constants.ACTION_TYPE_HEART,
                  env: _constants.ENV_PRO
                };
                return _context2.abrupt("return", this.report((0, _objectSpread2.default)((0, _objectSpread2.default)({}, params), {}, {
                  action_type: _constants.ACTION_TYPE_HEART
                })));

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function reportHeart() {
        return _reportHeart.apply(this, arguments);
      }

      return reportHeart;
    }()
    /**
     * 基础协议上报
     * @param params
     */

  }, {
    key: "report",
    value: function () {
      var _report = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(params, options) {
        var _params$act, _params$action_type, _params$module, _params$page, _params$component, _params$env, _sendParams$moreinfo, _this$getOptions2, beforeSend, onSessionUpdate, presetParams, sendParams, pass, _storage$getRaw, lastSession, nextSession, _ref, immediately, isHttpReport, reportNow, instance, reportParamsEncoded, moreinfoEncoded, res;

        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _this$getOptions2 = this.getOptions(), beforeSend = _this$getOptions2.beforeSend, onSessionUpdate = _this$getOptions2.onSessionUpdate;
                _context3.next = 4;
                return this.getBaseParams();

              case 4:
                presetParams = _context3.sent;
                sendParams = (0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, presetParams), params), {}, {
                  act: (_params$act = params.act) !== null && _params$act !== void 0 ? _params$act : _constants.ACT,
                  action_type: (_params$action_type = params.action_type) !== null && _params$action_type !== void 0 ? _params$action_type : _constants.DEFAULT_CODE,
                  module: (_params$module = params.module) !== null && _params$module !== void 0 ? _params$module : _constants.DEFAULT_CODE,
                  page: (_params$page = params.page) !== null && _params$page !== void 0 ? _params$page : _constants.DEFAULT_CODE,
                  component: (_params$component = params.component) !== null && _params$component !== void 0 ? _params$component : _constants.DEFAULT_CODE,
                  env: (_params$env = params.env) !== null && _params$env !== void 0 ? _params$env : _constants.ENV_PRO
                });
                this.setSendParams(sendParams);

                if (!(beforeSend && typeof beforeSend === 'function')) {
                  _context3.next = 11;
                  break;
                }

                _context3.next = 10;
                return beforeSend(sendParams);

              case 10:
                sendParams = _context3.sent;

              case 11:
                pass = this.checkParams(sendParams);

                if (pass) {
                  _context3.next = 14;
                  break;
                }

                return _context3.abrupt("return");

              case 14:
                if (!(_storage.default.isExpired(_constants.SESSION_ID_KEY) && typeof onSessionUpdate === 'function')) {
                  _context3.next = 25;
                  break;
                }

                lastSession = ((_storage$getRaw = _storage.default.getRaw(_constants.SESSION_ID_KEY)) === null || _storage$getRaw === void 0 ? void 0 : _storage$getRaw.value) || null;
                nextSession = _baseParams.default.getSessionId();
                _context3.prev = 17;
                _context3.next = 20;
                return onSessionUpdate(lastSession, nextSession);

              case 20:
                _context3.next = 25;
                break;

              case 22:
                _context3.prev = 22;
                _context3.t0 = _context3["catch"](17);
                console.error(_context3.t0);

              case 25:
                _ref = options || {}, immediately = _ref.immediately, isHttpReport = _ref.isHttpReport, reportNow = _ref.reportNow;
                instance = this.getInstance();
                reportParamsEncoded = Tracker.encodeParams(sendParams);
                moreinfoEncoded = Tracker.encodeParams((_sendParams$moreinfo = sendParams.moreinfo) !== null && _sendParams$moreinfo !== void 0 ? _sendParams$moreinfo : {});
                reportParamsEncoded.moreinfo = moreinfoEncoded; // this.reportMetric(sendParams, isHttpReport);

                if (!this.debugMode) {
                  _context3.next = 36;
                  break;
                }

                console.groupCollapsed("Tracker Debug(reportV2):Wait Mode:".concat(this.options.wait, ".event_id:").concat(sendParams.event_id, " immediately:").concat(!!immediately, " isHttpReport:").concat(!!isHttpReport, " reportNow:").concat(!!reportNow));
                console.table(sendParams);
                console.table(reportParamsEncoded);
                console.groupEnd();
                return _context3.abrupt("return");

              case 36:
                res = isHttpReport ? instance === null || instance === void 0 ? void 0 : instance.httpInstance.report(reportParamsEncoded, reportNow) : instance === null || instance === void 0 ? void 0 : instance.report(reportParamsEncoded, reportNow);

                if (immediately) {
                  instance.post();
                }

                return _context3.abrupt("return", res);

              case 41:
                _context3.prev = 41;
                _context3.t1 = _context3["catch"](0);
                console.log("collect tracker error:", _context3.t1);
                throw _context3.t1;

              case 45:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 41], [17, 22]]);
      }));

      function report(_x, _x2) {
        return _report.apply(this, arguments);
      }

      return report;
    }()
  }, {
    key: "reportJudge",
    value: function reportJudge(eventId, params, immediately, isHttpReport, reportNow) {
      if (this.debugMode) {
        console.groupCollapsed("Tracker Debug:".concat(eventId, "-").concat(params.event_name, ". Wait Mode:").concat(this.options.wait, ". immediately:").concat(immediately));
        console.table(params);
        console.groupEnd();
      }

      if (this.options.env === 'product') {
        var paramsEncoded = Tracker.encodeParams(params);
        var instance = this.getInstance();
        var session_create_type = paramsEncoded.session_create_type,
            last_session_id = paramsEncoded.last_session_id,
            restParams = (0, _objectWithoutProperties2.default)(paramsEncoded, _excluded);
        var reportParams = {
          prodid: _constants.PROD_ID,
          eventid: eventId,
          ref: document.referrer,
          act: _constants.LEGACY_ACT,
          session_create_type: session_create_type,
          last_session_id: last_session_id,
          moreinfo: restParams
        };
        var res = isHttpReport ? instance === null || instance === void 0 ? void 0 : instance.httpInstance.report(reportParams, reportNow) : instance === null || instance === void 0 ? void 0 : instance.report(reportParams, reportNow);

        if (immediately) {
          instance.post();
        }

        return res;
      }

      return Promise.resolve();
    }
    /**
     * 转义上报的参数
     * @param params
     * @returns
     */

  }]);
  return Tracker;
}();

Tracker.encodeParams = function (params) {
  return Object.keys(params).reduce(function (memo, key) {
    try {
      memo[key] = !_constants.NOT_ENCODES_LIST.includes(key) ? encodeURIComponent(params[key] || '') : params[key];
    } catch (error) {
      console.log('[tracker] encodeURIComponent params error:', error);
      memo[key] = params[key];
    }

    return memo;
  }, {});
};

var _default = Tracker;
exports.default = _default;